import UAParser from 'ua-parser-js'
import { getUserAgent } from '../helpers/getUserAgent'
import { TAdInfo, TAdIsLat } from '../types'
import { encodeObjectValues } from './encodeObjectValues'
import { getDeviceAdId } from './getDeviceAdId'

export const getWebAdInfo = (): TAdInfo => {
  const ua = new UAParser(getUserAgent())
  const device = ua.getDevice()
  const os = ua.getOS()
  const rawAdInfo = {
    platform: os?.name ?? 'Web',
    did: getDeviceAdId(),
    is_lat: TAdIsLat.FALSE,
    device_make: device?.vendor ?? 'unknown',
    device_model: device?.model ?? 'unknown',
    osversion: os.version ?? 'unknown',
  }
  return encodeObjectValues(rawAdInfo)
}
